import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function MetaPixelRouterTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.fbq !== "function") return;

    let pagePath = location.pathname;

    // Normalize dynamic segments — same pattern as your GtagRouterTracker
    if (/\/qr\/\w+/.test(pagePath)) {
      pagePath = "/qr/[id]";
    }

    window.fbq("track", "PageView");
  }, [location]);

  return null;
}

export default MetaPixelRouterTracker;
